import React from 'react'
import { Btn2, HeadingText } from '../StyledComponents'
import { Box, Grid, Typography } from '@mui/material'
import Education from './Education'
import Experience from './Experience'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom'

function Resume() {
  return (
    <>
        <Box id="resume" my={5}>
            <Box sx={{textAlign:"center"}} data-aos="fade-up" data-aos-duration="2000">
              <HeadingText text="Resume" mb={5} variant='h1' >
                  Resume
              </HeadingText>
              <Typography variant='h7' color="shade.light" >
                Combining hands-on experience with a solid educational background, I deliver innovative, scalable solutions in full-stack development.
              </Typography>
            </Box>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item xs={12} sm={12} md={6}>
                <Education/>
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <Experience/>
              </Grid>
            </Grid>
           <Box sx={{display:"flex",justifyContent:"center"}} data-aos="fade-up" data-aos-duration="2000">
              <Btn2
                component={Link}
                to="/resume"
                sx={{
                  fontSize:{xs:"0.8rem",sm:"1rem",md:"1.08rem"},
                  padding:{xs:"5px 20px",sm:"5px 25px",md:"5px 35px"},
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"center",
                  gap:1,
                  '&:after':{
                    height:"100%",
                  },
                  '&:hover:after':{
                      height:"0%"
                  } 
                }}
              >
                Resume
                <ArrowForwardIcon/>

              </Btn2>
           </Box>
        </Box>
      </>
  )
}

export default Resume